import Support from "@mui/icons-material/Support";
import { Button } from "@mui/material";
import { useSidebar2026 } from "../../../hooks/use-sidebar-2026";

import type { FC } from "react";

export const NeedHelp: FC = () => {
  const sidebar2026 = useSidebar2026();

  return (
    <Button
      size="small"
      // In the 2026 sidebar, coloured like the nav items.
      sx={{ color: sidebar2026 ? "var(--nav-item-color)" : "text.sidebar", p: 0 }}
      data-analytics-id="sidebar-need-help"
      variant="text"
      startIcon={<Support />}
      href="https://help.changeengine.com"
      target="_blank"
    >
      {sidebar2026 ? "Help" : "Need help?"}
    </Button>
  );
};
